/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Searchplaceholder2Inputs */

const zh_admincredit_searchplaceholder2 = /** @type {(inputs: Admincredit_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索用户名或邮箱...`)
};

const en_admincredit_searchplaceholder2 = /** @type {(inputs: Admincredit_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search username or email...`)
};

const es_admincredit_searchplaceholder2 = /** @type {(inputs: Admincredit_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar por nombre o correo...`)
};

/**
* | output |
* | --- |
* | "Search username or email..." |
*
* @param {Admincredit_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_searchplaceholder2 = /** @type {((inputs?: Admincredit_Searchplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Searchplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_searchplaceholder2(inputs)
	if (locale === "en") return en_admincredit_searchplaceholder2(inputs)
	return es_admincredit_searchplaceholder2(inputs)
});
export { admincredit_searchplaceholder2 as "adminCredit_searchPlaceholder" }